export default __webpack_public_path__ + "static/media/smART_Manager.130a4b09.png";